import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { checkOTP, forgotPassword } from "../../core/service/api_profile";
import logoWhite from "../../assets/images/logo-white.svg";
import logoCompany from "../../assets/images/logo-company.svg";
import ellipse1 from "../../assets/images/icon_login/ellipse1.svg";
import ellipse2 from "../../assets/images/icon_login/ellipse2.svg";
import { toast } from "react-toastify";
import Countdown, { zeroPad } from "react-countdown";
import { useDispatch } from "react-redux";
import { setLoading } from "../../core/feature/config/configSlice";
import { BackButton } from "../common/BackButton";
import OtpInput from "react-otp-input";
import { resend_otp } from "../../core/service/api";
import moment from "moment";

const ComponentForgotPasswordOTP = () => {
  const { t } = useTranslation();
  const [otp, setOtp] = useState("");
  const [data, setData] = useState<any>({});
  const navigate = useNavigate();
  const location: any = useLocation();
  const [timer, setTimer] = useState(0);
  const [countSend, setCountSend] = useState(0);
  const [countdown, setCountdown] = useState(false);
  const dispatch = useDispatch();
  const [code, setCode] = useState("");
  const [count, setCount] = useState(0)

  const handleChange = (code: any) => {
    setCode(code);
    setOtp(code);
    console.log(code, "cek");
  };

  const renderer = (
    // { hours, minutes, seconds, completed }
    data: any
  ) => {
    if (data.completed) {
      setCountdown(false);
      return (
        <button
          className="text-psp-primary font-medium text-center text-sm font-montserrat"
          onClick={() => {
            setOtp("");
            setCountSend(0);
            setTimer(Date.now() + 300000);
            resendOtp();
          }}
        >
          {t("LOGIN.send")}
        </button>
      );
    } else {
      setCountdown(true);
      // Render a countdown
      return (
        <span className="text-psp-nav font-medium text-center text-sm font-montserrat">
          {zeroPad(data.minutes)}:{zeroPad(data.seconds)}
        </span>
      );
    }
  };

  const disabledButton = (data: any) => {
    if (data.completed) {
      setCountdown(false);
    }
  };

  const validationOtp = async () => {
    var body =
    {
      phoneEmail: data.phoneEmail,
      sendVia: data.sendVia,
      reqTime: moment().format("DD-MM-YYYY hh:mm:ss"),
    }

    resend_otp(body).then((resp) => {

    }).catch((e) => {

    })
  };

  const resendOtp = async () => {
    var query = {
      newPassword: "",
      otp: "",
      phoneEmail: data.phoneEmail,
      sendVia: data.sendVia,
      reqTime: data.reqTime,
    };
    dispatch(setLoading(true));
    forgotPassword(query)
      .then((res) => {
        dispatch(setLoading(false));
        setCountdown(false);
      })
      .catch((err: any) => {
        dispatch(setLoading(false));
      });
    validationOtp()
  };

  const funCheckOTP = async () => {
    var query: any = { newPassword: "", otp: otp, phoneEmail: data.phoneEmail };
    checkOTP(query)
      .then((res) => {
        query.sendVia = data.sendVia;
        query.reqTime = data.reqTime;
        console.log(query);
        toast.success(t("LOGIN.notif"));
        navigate("/forgot-password-create", {
          state: { data: JSON.stringify(query) },
        });
      })
      .catch((err: any) => {
        console.log(err);
        setCountSend(countSend + 1);

      });
  };

  useEffect(() => {
    setTimer(Date.now() + 300000);
    setCountdown(false);
    setData(JSON.parse(location?.state?.data));
    console.log(JSON.parse(location?.state?.data));
  }, []);
  return (
    <>
      <div className="relative font-poppins p-0 m-0 bg-psp-primary">
        <div className="flex min-h-screen">
          <div className="relative overflow-visible w-3/12 sm:w-1/2 md:w-3/12 flex-0 bg-psp-login ">
            <img
              src={ellipse1}
              className="absolute bottom-0 left-0 z-0 select-none"
            />
            <img
              src={ellipse2}
              className="absolute top-0 left-0 z-0 select-none"
            />

            <div className="flex flex-col gap-10 w-full">
              <div className="flex flex-col z-10 gap-8 items-start">
                {/* <img src={vector1} className="ml-32 sm:ml-12 md:ml-32" /> */}
                <div className="px-10 mt-36 sm:px-10  md:px-10 md:mt-20 sm:mt-0">
                  <img src={logoWhite} className="z-10 h-14 select-none" />
                  <p className="text-white z-10 mt-6 text-xs font-light">
                    {t("LOGIN.description")}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="grow p-12 bg-psp-primary relative">
            <section className="flex flex-col mt-14">
              <h1 className="font-montserrat m-0 font-bold text-sm text-black text-center">
                {t("LOGIN.otpTitle")}
              </h1>
              <p className="font-montserrat mt-2 font-medium text-xs text-black text-center">
                {t("LOGIN.otpDesc")}
              </p>
              <h1 className="font-montserrat m-0 font-bold text-sm text-black text-center">
                {t("LOGIN.otpInput")}
              </h1>
              <div className="flex mx-auto my-2">
                <OtpInput
                  value={code}
                  onChange={(code: any) => handleChange(code)}
                  numInputs={5}
                  separator={<span style={{ width: "10px" }}></span>}
                  isInputNum={true}
                  shouldAutoFocus={true}
                  inputStyle={{
                    border: "1px solid transparent",
                    borderRadius: "8px",
                    width: "54px",
                    height: "54px",
                    fontSize: "15px",
                    color: "#000",
                    fontWeight: "400",
                    caretColor: "blue",
                  }}
                  focusStyle={{
                    border: "1px solid #CFD3DB",
                    outline: "none",
                  }}
                />
              </div>
              {/* <input
                // type={"number"}
                onChange={(e) => setOtp(e.target.value)}
                maxLength={5}
                className="px-3 py-2.5 rounded-lg lining-nums font-montserrat font-medium tracking-wide text-center my-2"
              ></input> */}
              <Countdown key={timer} date={timer} renderer={renderer} />
              <hr />
              {countSend > 2 ?
                <button
                  onClick={() => navigate(-1)}
                  className="mt-2 bg-[#FFC31A] text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
                >
                  {t("OTHER.back")}
                </button>
                : (
                  <button
                    disabled={data.completed}
                    onClick={() => funCheckOTP()}
                    className="mt-2 bg-psp-btn-primary text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active disabled:bg-slate-300"
                  >
                    {t("LOGIN.otpConfirm")}
                  </button>
                )}
              {/* <button
                onClick={() => navigate(-1)}
                className="mt-2 bg-[#FFC31A] text-white font-bold w-full py-2 rounded-lg hover:text-red-600 hover:ring-2 hover:ring-offset-cyan-600  active:bg-psp-active"
              >
                {t("OTHER.back")}
              </button> */}
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default ComponentForgotPasswordOTP;
